import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const ShirtsCopy = () => (
  <Layout1x1>
    <h3 className="text-h2">Shirts</h3>
    <Line className="!text-gray-dark" />
    <p className="!mb-64 text-gray-darker">
      Whether you're suiting up for a big meeting or getting dressed for a black-tie event, we've got you covered with dress shirts in a
      wide range of styles and colors. Our shirts are made from high-quality materials, ensuring a comfortable fit and a polished look that
      will make you stand out even with your jacket off.
    </p>

    <h3 className="text-h2">Shirt Colors</h3>
    <Line className="!text-gray-dark" />
    <p className="!mb-64 text-gray-darker">
      Our shirt collection includes classic white dress shirts that are perfect for any occasion, as well as a variety of{' '}
      <Link href={`${process.env.NEXT_PUBLIC_APP_URL}/swatch/build`} className="tracker-text-shirts_collection-230130-144024">
        other colors
      </Link>{' '}
      from pink to black that will add a pop of personality to your formal attire.
    </p>

    <h3 className="text-h2">Shirt Patterns</h3>
    <Line className="!text-gray-dark" />
    <p className="text-gray-darker">
      Choose from a range of patterns, including traditional solid shirts, checks, plaids, and{' '}
      <Link href="/collection/shirts/aqua-gingham-shirt" className="tracker-text-shirts_collection-230130-144050">
        ginghams
      </Link>
      . Our tuxedo shirts are specially designed to complement any{' '}
      <Link href="/collection/tuxedos-and-suits" className="tracker-text-shirts_collection-230130-144123">
        suit or tuxedo
      </Link>
      , and feature sleek, modern designs that will make you look and feel your best.
    </p>
  </Layout1x1>
);

export default ShirtsCopy;
